import { Route, Routes } from 'react-router'

import { NotFound } from 'js/core/NotFound'
import ListWrapper from 'js/magazine/List/ListWrapper'
import View from 'js/magazine/View/View'
import RequireAuth from 'js/router/RequireAuth'

export const MagazinesRoutes = () => (
    <Routes>
        <Route
            index
            element={
                <RequireAuth
                    viewer="canWriteToContainer"
                    canWriteToContainerSubtype="magazine"
                >
                    <ListWrapper />
                </RequireAuth>
            }
        />
        <Route path="*" element={<NotFound />} />
    </Routes>
)

export const MagazineRoutes = () => (
    <Routes>
        <Route path="view/:guid" element={<View />} />
        <Route path="view/:guid/:slug" element={<View />} />
        <Route path="*" element={<NotFound />} />
    </Routes>
)
